module.exports = __webpack_public_path__ + "static/media/toolbar-zoom-out.c6534220.svg";